export default "__VITE_ASSET__zgSnlr5u__"